export default __webpack_public_path__ + "assets/magnifier-1388c50e8837f1c805d17ebef40cb60e.svg";